import { MaterialCommunityIcons } from "@expo/vector-icons";
import React from "react";
import { Pressable, StyleSheet, Text, View } from "react-native";

type Props = {
  emptyTitle: string;
  emptySubtitle?: string;
  primaryMaterialCommunityIconName: keyof typeof MaterialCommunityIcons.glyphMap;
  actionButtonMaterialCommunityIconName?: keyof typeof MaterialCommunityIcons.glyphMap;
  actionButtonText?: string;
  onActionButtonPress?: () => void;
};

function EmptyContentView({
  emptyTitle,
  emptySubtitle,
  primaryMaterialCommunityIconName,
  actionButtonMaterialCommunityIconName,
  actionButtonText,
  onActionButtonPress = (): void => {},
}: Props): React.JSX.Element {
  return (
    <>
      <View style={styles.container}>
        <View style={styles.iconContainer}>
          <MaterialCommunityIcons
            name={primaryMaterialCommunityIconName}
            size={48}
            color="#CCCCCC"
          />
        </View>
        <Text style={styles.emptyTitle}>{emptyTitle}</Text>
        {emptySubtitle && (
          <Text style={styles.emptySubtitle}>{emptySubtitle}</Text>
        )}
        {actionButtonText && (
          <Pressable style={styles.button} onPress={onActionButtonPress}>
            {actionButtonMaterialCommunityIconName && (
              <MaterialCommunityIcons
                name={actionButtonMaterialCommunityIconName}
                size={16}
                color="#333"
                style={styles.buttonIcon}
              />
            )}
            <Text style={styles.buttonText}>{actionButtonText}</Text>
          </Pressable>
        )}
      </View>
    </>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    padding: 24,
  },
  iconContainer: {
    width: 96,
    height: 96,
    borderRadius: 48,
    backgroundColor: "#F5F5F5",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 16,
  },
  emptyTitle: {
    fontSize: 16,
    fontWeight: "500",
    color: "#333",
    marginBottom: 4,
  },
  emptySubtitle: {
    fontSize: 14,
    color: "#888",
    marginBottom: 16,
    textAlign: "center",
  },
  button: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 16,
    paddingVertical: 8,
    marginTop: 16,
    borderWidth: 1,
    borderColor: "#333",
    borderRadius: 24,
  },
  buttonIcon: {
    marginRight: 6,
  },
  buttonText: {
    fontSize: 14,
    color: "#333",
    fontWeight: "500",
  },
});

export default EmptyContentView;
